import React, { Component } from 'react';
//components

//styles
import './scss/header.scss';
import DecadesYears from '../DecadesYears/DecadesYears';

class MobileMenu extends Component {
  shareWhatsapp = () => {
    let url = 'whatsapp://send?text=https://z.ynet.co.il/mshort/content/2018/GolshimBaZman/#';
    window.open(url, '_blank', "width=500,height=300");
    this.props.sendGA("Share_Whatsapp", url);
  }

  render() {
    return (
      <div className="mobile-menu" style={{ "transform": "translateX(" + this.props.transform + "%)" }}>
        <div className="close-btn" onClick={this.props.closeMenu}></div>
        <div className="main-image"></div>
        <DecadesYears
          decadesJSON={this.props.decadesJSON}
          showSelectTransform={true}
          currentDecade={this.props.currentDecade}
          closeMenu={this.props.closeMenu} 
          sendGA={this.props.sendGA}/>
        <ul className="menu-list" id="menu">
          <a href="mailto:redmailynet@gmail.com" target="_blank">
            <li className="write-us">כתבו לנו</li>
          </a>
          <li className="whatsapp" onClick={this.shareWhatsapp}></li>
          <li className="facebook" onClick={this.props.shareFacebook}></li>
          <li className="accessibility" onClick={this.props.negishut}></li>
        </ul>
      </div>
    );
  }
}

export default MobileMenu;



// WEBPACK FOOTER //
// ./src/Components/Header/MobileMenu.js